import React from 'react';
import cn from 'classnames';
import { CardStyleProps } from 'apps/sigma2-ui/src/components/ui/CardStyle';

/**
 * Card with no shadow
 */
export const FlatCard: React.FC<
  {
    children: React.ReactNode;
    className?: string;
  } & CardStyleProps
> = ({ children, className, paddingClassName }) => {
  return (
    <div
      className={cn(
        'rounded-md',
        paddingClassName ? paddingClassName : 'p-3',
        className,
      )}
    >
      {children}
    </div>
  );
};
